import { capitalizeWords } from "./FormatNoteNameAndText";




export function convertErrorMsgToAlertMsg(error_msg) {
    switch(error_msg) {
        case "invalid_method": {
            return "Your account has not been configured to be authorized through this method. Please use your original way of logging in."
        }
        case "failed_auth_exchange": {
            return "Your SSO token couldn't be exchanged for authorization to your account. Please try again or contact support."
        } default: {
            return capitalizeWords(error_msg, "_")
        }
    }
}